var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #494848;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Challenge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "challenge_group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "challenge_path_6",
    className: "cls-1",
    points: "24 6.5 20.65 9.94 20.63 9.93 20.54 3.16 20.55 3.14 24 6.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "challenge_path_5",
    className: "cls-1",
    points: "0 6.47 3.35 9.93 3.36 9.91 3.47 3.14 3.45 3.13 0 6.47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "challenge_path_4",
    className: "cls-1",
    x: 8.97,
    y: 17.73,
    width: 6.29,
    height: 3.14,
    transform: "translate(.02 -.01) rotate(.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "challenge_path_3",
    className: "cls-1",
    x: 8.97,
    y: 13.1,
    width: 6.29,
    height: 3.14,
    transform: "translate(26.8 2.57) rotate(90.06)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "challenge_path_2",
    className: "cls-1",
    d: "m11.75,11.69c.11,0,.21,0,.32,0l-.08-8.44-8.45.08v.32c.04,4.49,3.72,8.1,8.2,8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "challenge_path_1",
    className: "cls-1",
    d: "m12.39,11.68c-.11,0-.21,0-.32,0l-.08-8.44,8.45-.08v.32c.04,4.49-3.56,8.16-8.05,8.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChallenge);
export default __webpack_public_path__ + "static/media/icon_challenge.4a37ab6eb5b371419ac1ba37d3e415bc.svg";
export { ForwardRef as ReactComponent };